import { Divider, Grid, InputLabel } from '@material-ui/core';
import RetencaoAliquotaModal from 'app/main/servico/components/modal/Retencoes/RetencaoAliquotaModal';
import * as Actions from 'app/store/actions';
import { FieldArray } from 'formik';
import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import AtualizarAliquotaModal from './AtualizarAliquotaModal';
import ProdutoServicoItem from './ProdutoServicoItem';
import { produtoServicoListStyles } from './styles';

const ProdutoServicoList = ({
  id,
  name,
  handleAddProdutoServico,
  handleRemoveProdutoServico,
  onChange,
  onBlur,
  value,
  errors,
  touched,
  submitCount,
  possuiNotaFiscalTransmitida,
  possuiCobrancaRegistrada,
  soProduto,
  exibeMsgProdutoSemEstoque = true,
  aceitaProdutoImobilizado = false,
  atualizarAliquotaProps = {},
  retencaoAliquotaProps = {},
  origemIntegracao,
  modalRetencaoAliquota,
  setModalRetencaoAliquota,
}) => {
  const styles = produtoServicoListStyles();

  const [modalAtualizarAliquota, setModalAtualizarAliquota] = useState('');
  const [indexProdutoSelecionado, setIndexProdutoSelecionado] = useState();
  const [indexServicoSelecionado, setIndexServicoSelecionado] = useState();

  const handlerAtualizarAliquota = (index) => {
    setIndexProdutoSelecionado(index);
    setModalAtualizarAliquota('atualizarAliquota');
  };

  const handlerRetencaoAliquota = (index) => {
    setIndexServicoSelecionado(index);
    setModalRetencaoAliquota('retencaoAliquota');
  };

  const handlerSubmitAtualizarAliquota = (produto) => {
    if (value[indexProdutoSelecionado].fiscal?.id) {
      value[indexProdutoSelecionado].fiscal = Object.assign(
        { id: value[indexProdutoSelecionado].fiscal?.id },
        produto.fiscal
      );
    } else {
      value[indexProdutoSelecionado].fiscal = Object.assign({}, produto.fiscal);
      value[indexProdutoSelecionado].fiscal.id = null;
    }
    setModalAtualizarAliquota('');
  };

  const dispatch = useDispatch();
  const showError = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'error' }));
  };

  const validarRetencoesValor = (produtoServico, servicoFiscal) => {
    const valorVenda = produtoServico?.valor;

    let somatorio = 0;

    if (servicoFiscal?.tipoIss === 'VALOR' && servicoFiscal?.issRetidoNaFonte) {
      somatorio += servicoFiscal?.valorIss;
    }

    if (servicoFiscal?.tipoIrrf === 'VALOR' && servicoFiscal?.irrfRetidoNaFonte) {
      somatorio += servicoFiscal?.valorIrrf;
    }

    if (servicoFiscal?.tipoPis === 'VALOR' && servicoFiscal?.pisRetidoNaFonte) {
      somatorio += servicoFiscal?.valorPis;
    }

    if (servicoFiscal?.tipoCofins === 'VALOR' && servicoFiscal?.cofinsRetidoNaFonte) {
      somatorio += servicoFiscal?.valorCofins;
    }

    if (servicoFiscal?.tipoInss === 'VALOR' && servicoFiscal?.inssRetidoNaFonte) {
      somatorio += servicoFiscal?.valorInss;
    }

    if (servicoFiscal?.tipoCsll === 'VALOR' && servicoFiscal?.csllRetidoNaFonte) {
      somatorio += servicoFiscal?.valorCsll;
    }

    const diferenca = valorVenda - somatorio;

    if (diferenca < 0) {
      showError('A soma das retenções nominais não podem ultrapassar o valor de venda do serviço.');
      return false;
    }

    return true;
  };

  const validarRetencoesPercentual = (servicoFiscal) => {
    let somatorio = 0;

    if (servicoFiscal?.tipoIss === 'PERCENTUAL' && servicoFiscal?.issRetidoNaFonte) {
      somatorio += servicoFiscal?.valorIss;
    }

    if (servicoFiscal?.tipoIrrf === 'PERCENTUAL' && servicoFiscal?.irrfRetidoNaFonte) {
      somatorio += servicoFiscal?.valorIrrf;
    }

    if (servicoFiscal?.tipoPis === 'PERCENTUAL' && servicoFiscal?.pisRetidoNaFonte) {
      somatorio += servicoFiscal?.valorPis;
    }

    if (servicoFiscal?.tipoCofins === 'PERCENTUAL' && servicoFiscal?.cofinsRetidoNaFonte) {
      somatorio += servicoFiscal?.valorCofins;
    }

    if (servicoFiscal?.tipoInss === 'PERCENTUAL' && servicoFiscal?.inssRetidoNaFonte) {
      somatorio += servicoFiscal?.valorInss;
    }

    if (servicoFiscal?.tipoCsll === 'PERCENTUAL' && servicoFiscal?.csllRetidoNaFonte) {
      somatorio += servicoFiscal?.valorCsll;
    }

    if (somatorio > 100) {
      showError('A soma das retenções do tipo percentual não podem ultrapassar 100%.');
      return false;
    }

    return true;
  };

  const handlerSubmitRetencaoAliquota = (servicoFiscal) => {
    const isUtilizadoIbsCbs =
      servicoFiscal?.cstSituacaoTributaria?.id ||
      servicoFiscal?.cstClassificacaoTributaria?.id ||
      servicoFiscal?.valorIbs > 0 ||
      servicoFiscal?.valorIbsMunicipal > 0 ||
      servicoFiscal?.valorCbs > 0 ||
      servicoFiscal?.valorIs > 0;

    servicoFiscal.possuiIbsCbs = !!isUtilizadoIbsCbs;

    const isValidadoRetencoesPercentual = validarRetencoesPercentual(servicoFiscal);
    const isValidadoRetencoesValor = isValidadoRetencoesPercentual
      ? validarRetencoesValor(value[indexServicoSelecionado], servicoFiscal)
      : false;

    if (isValidadoRetencoesPercentual && isValidadoRetencoesValor) {
      const servicoFiscalAtualizado = value[indexServicoSelecionado].servicoFiscal?.id
        ? Object.assign({ id: value[indexServicoSelecionado].servicoFiscal.id }, servicoFiscal)
        : Object.assign({ id: null }, servicoFiscal);

      value[indexServicoSelecionado].servicoFiscal = servicoFiscalAtualizado;
      value[indexServicoSelecionado].produtoServico = {
        ...value[indexServicoSelecionado].produtoServico,
        servicoFiscal: servicoFiscalAtualizado,
      };

      if (onChange) {
        onChange({
          target: {
            id: name,
            value: value.map((item, index) =>
              index === indexServicoSelecionado
                ? {
                    ...item,
                    servicoFiscal: servicoFiscalAtualizado,
                    produtoServico: {
                      ...item.produtoServico,
                      servicoFiscal: servicoFiscalAtualizado,
                    },
                  }
                : item
            ),
          },
        });
      }

      setModalRetencaoAliquota('');
    }
  };

  return (
    <>
      <Grid container spacing={3} className={`mb-8 ${styles.container}`}>
        <Grid item xs={4}>
          <InputLabel id="situacao">{soProduto ? 'Nome do produto' : 'Nome do produto/serviço *'}</InputLabel>
        </Grid>
        <Grid item xs={2}>
          <InputLabel id="situacao">Quantidade *</InputLabel>
        </Grid>
        <Grid item xs={2}>
          <InputLabel id="situacao">Valor (R$) *</InputLabel>
        </Grid>
        <Grid item xs={2}>
          <InputLabel id="situacao">Subtotal (R$)</InputLabel>
        </Grid>
      </Grid>
      <Divider className={styles.divider} />

      <FieldArray
        name="produtosServicos"
        render={(arrayHelpers) => {
          return (
            <>
              {value
                ?.filter((item) => !!item)
                ?.map((item, i) => {
                  return (
                    <Fragment key={item.key}>
                      <ProdutoServicoItem
                        values={item}
                        onChange={onChange}
                        onBlur={onBlur}
                        index={i}
                        id={`${id}[${i}]`}
                        name={`${name}[${i}]`}
                        errors={(errors?.produtosServicos?.length >= i && errors.produtosServicos[i]) || {}}
                        touched={(touched?.produtosServicos?.length >= i && touched.produtosServicos[i]) || {}}
                        arrayHelpers={arrayHelpers}
                        onRemove={handleRemoveProdutoServico}
                        showDivider={value?.length > 1 && i !== value?.length - 1}
                        submitCount={submitCount}
                        disabled={possuiNotaFiscalTransmitida || possuiCobrancaRegistrada}
                        atualizarAliquota={handlerAtualizarAliquota}
                        retencaoAliquota={handlerRetencaoAliquota}
                        soProduto={soProduto}
                        exibeMsgProdutoSemEstoque={exibeMsgProdutoSemEstoque}
                        aceitaProdutoImobilizado={aceitaProdutoImobilizado}
                        origemIntegracao={origemIntegracao}
                      />
                    </Fragment>
                  );
                })}
              {!possuiNotaFiscalTransmitida && !possuiCobrancaRegistrada && (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <button
                      className={styles.buttonAdicionarProdutoServico}
                      type="button"
                      href=""
                      onClick={handleAddProdutoServico}
                    >
                      {soProduto ? 'Adicionar produto' : 'Adicionar produto/serviço'}
                    </button>
                  </Grid>
                </Grid>
              )}
            </>
          );
        }}
      />

      {indexProdutoSelecionado !== undefined && (
        <AtualizarAliquotaModal
          modalAtualizarAliquota={modalAtualizarAliquota}
          setModalAtualizarAliquota={setModalAtualizarAliquota}
          produtoServico={value[indexProdutoSelecionado]}
          onSubmit={handlerSubmitAtualizarAliquota}
          props={atualizarAliquotaProps}
          isVenda={true}
        />
      )}

      {indexServicoSelecionado !== undefined && (
        <RetencaoAliquotaModal
          modalRetencaoAliquota={modalRetencaoAliquota}
          setModalRetencaoAliquota={setModalRetencaoAliquota}
          produtoServico={value[indexServicoSelecionado]}
          onSubmit={handlerSubmitRetencaoAliquota}
          origemVenda={true}
        />
      )}
    </>
  );
};

export default ProdutoServicoList;
